import { useMediaCompanyThematicBlockUpdateMutation } from '@shared/api/graphql/generated';

const useCompanyThematicBlockUpdate = () => {
  const [mutation, data] = useMediaCompanyThematicBlockUpdateMutation();

  const request = async (
    startDate: string,
    endDate: string,
    companyThematicBlockId: string,
    streamsIds: string[],
    addToAllStreams: boolean
  ) => {
    const mutationResult = await mutation({
      variables: {
        input: {
          startDate,
          endDate,
          companyThematicBlockId,
          streamsIds,
          addToAllStreams,
        },
      },
    });
    return !!mutationResult.data?.result?.ok;
  };

  return {
    request,
    error: data.error,
    loading: data.loading,
  };
};

export default useCompanyThematicBlockUpdate;
